export default "__VITE_ASSET__DvsgF44h__"